import type { UUID } from "../../../utils/uuid";

export interface Claims {
  org_id: string;
  org_name: string;
  sub: string;
  role: string;
  "http://changeengine.com/supabase_url": string;
  "http://changeengine.com/supabase_anon_key": string;
  "http://changeengine.com/account_id": UUID;
  "http://changeengine.com/person_id": UUID;
  "http://changeengine.com/ce_admin": boolean;
  "http://changeengine.com/super_admin": boolean;
  "http://changeengine.com/editable_program": UUID[] | null;
  "http://changeengine.com/read_only_program": UUID[] | null;
  "http://changeengine.com/token_version"?: number | null;
}

export const getClaims = (token: string): Claims =>
  // oxlint-disable-next-line typescript/no-unsafe-type-assertion
  JSON.parse(atob(token.split(".")[1]!)) as Claims;
